import React from 'react';

import { BookingContext } from '@app/components/Pages/Booking/Booking';
import { BookingErrorCode } from '@app/components/Pages/Booking/model';
import { pushEvent } from '@app/components/TagManager';

const track = (event: string) => {
	pushEvent('onlineBookingErrorScreen', { screen: event });
};

const useOnlineBookingErrorTracking = () => {
	const context = React.useContext(BookingContext);

	if (!context?.state) throw new Error('Error context');

	const { state: { errorCode } } = context;

	if (!errorCode) return;

	React.useEffect(() => {
		switch (errorCode) {
			case BookingErrorCode.PetRequiresAttention:
				track('OLB_Pet_Disposition');
				break;
			case BookingErrorCode.LargePet:
				track('OLB_Crematory_Assistance');
				break;
			case BookingErrorCode.InvalidFamily:
				track('OLB_Flags');
				break;
			default:
				break;
		}
	}, [errorCode]);
};

export default useOnlineBookingErrorTracking;
